import { SystemAdminModeDenial } from 'shared/types'
import { setViewerMode, ViewerMode } from 'shared/utils'
import { useCheckSystemAdminModeAccess } from './use-check-system-admin-mode-access'

// The page is reloaded, so the data is loaded again in the system admin mode
export const useEnterSystemAdminMode = (
  onDenied: (denial: SystemAdminModeDenial) => void
) => {
  const checkSystemAdminModeAccess = useCheckSystemAdminModeAccess()

  return async () => {
    const denial = await checkSystemAdminModeAccess()

    if (denial) {
      onDenied(denial)
      return
    }

    setViewerMode(ViewerMode.SYSTEM_ADMIN)
    window.location.reload()
  }
}
